<div class="dialog-agent">
  <div mat-dialog-title>
    {{ 'GLOBAL.DOWNLOAD' | translate }}
  </div>
  <div mat-dialog-content class="">
    <div>

    <div class="w-100 d-inline-block py-2">
      <div class="notify notify-info wb-ball">
        <span class="notify-message">{{ 'WEB-SIGN.SIGNTRUST-LIB.DOWNLOAD-DOCUMENT' | translate }} <br> {{ 'WEB-SIGN.SIGNTRUST-LIB.DOWNLOAD-DOCUMENT2' | translate }}</span>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="w-100 px-0">
    <button mat-raised-button color="primary" class="ms-2 float-end" [mat-dialog-close]="true">
      <i class="rt-icon rt-archivo-1" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'WEB-SIGN.SIGNTRUST-LIB.DOWNLOAD-BTN' | translate }}</span>
    </button>
    <button mat-stroked-button color="primary" class="" [mat-dialog-close]="false">
      <i class="rt-icon rt-cerrar" *ngIf="isMobile"></i>
      <span *ngIf="!isMobile">{{ 'GLOBAL.NO' | translate }}</span>
    </button>
  </div>
</div>
